// extracted by mini-css-extract-plugin
module.exports = {"element":"Element_element__1V9eh","draggable":"Element_draggable__aeEoy","icon":"Element_icon__1GgMV"};